/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Types from '../../generated/types'

import { gql } from '@apollo/client'
import { ActionLinkFragmentDoc, NavLinkFragmentDoc, ExternalLinkFragmentDoc } from '../Footer/Footer.generated'
import { QuickLinkFragmentDoc } from '../QuickLink/QuickLink.generated'
import { PanelFragmentDoc } from '../Panel/Panel.generated'
export type ComponentMeta_ActivityLog_Fragment = {
  __typename?: 'ActivityLog'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_App_Fragment = {
  __typename?: 'App'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_AppInfo_Fragment = {
  __typename?: 'AppInfo'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_Chart_Fragment = {
  __typename?: 'Chart'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_DataTemplate_Fragment = {
  __typename?: 'DataTemplate'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_DataTemplateAction_Fragment = {
  __typename?: 'DataTemplateAction'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_Form_Fragment = {
  __typename?: 'Form'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_HierarchicalFilter_Fragment = {
  __typename?: 'HierarchicalFilter'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_Metric_Fragment = {
  __typename?: 'Metric'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_Page_Fragment = {
  __typename?: 'Page'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_ProjectInfo_Fragment = {
  __typename?: 'ProjectInfo'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_Support_Fragment = {
  __typename?: 'Support'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_Table_Fragment = {
  __typename?: 'Table'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_TemplateAction_Fragment = {
  __typename?: 'TemplateAction'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMeta_VegaLiteChart_Fragment = {
  __typename?: 'VegaLiteChart'
  id: string
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export type ComponentMetaFragment =
  | ComponentMeta_ActivityLog_Fragment
  | ComponentMeta_App_Fragment
  | ComponentMeta_AppInfo_Fragment
  | ComponentMeta_Chart_Fragment
  | ComponentMeta_DataTemplate_Fragment
  | ComponentMeta_DataTemplateAction_Fragment
  | ComponentMeta_Form_Fragment
  | ComponentMeta_HierarchicalFilter_Fragment
  | ComponentMeta_Metric_Fragment
  | ComponentMeta_Page_Fragment
  | ComponentMeta_ProjectInfo_Fragment
  | ComponentMeta_Support_Fragment
  | ComponentMeta_Table_Fragment
  | ComponentMeta_TemplateAction_Fragment
  | ComponentMeta_VegaLiteChart_Fragment

export type PageFragment = {
  __typename?: 'Page'
  title?: string | null
  id: string
  background?: { __typename?: 'Background'; imageUrl?: string | null } | null
  banner?: { __typename?: 'Banner'; title?: string | null; subtitle?: string | null } | null
  link?:
    | { __typename?: 'ActionLink'; label?: string | null; action?: Types.Action | null }
    | { __typename?: 'ExternalLink'; label?: string | null; externalLink?: string | null }
    | {
        __typename?: 'NavLink'
        appId?: string | null
        label?: string | null
        projectId?: number | null
        pageId?: string | null
        setParams?: Array<{ __typename?: 'Param'; key: string; value?: string | null }> | null
        toggleParams?: Array<{ __typename?: 'Param'; key: string; value?: string | null }> | null
      }
    | null
  quickLinks?: {
    __typename?: 'QuickLinks'
    position?: Types.QuickLinksPosition | null
    links?: Array<{
      __typename?: 'QuickLink'
      title?: string | null
      description?: string | null
      imageUrl?: string | null
      navLink: {
        __typename?: 'NavLink'
        appId?: string | null
        label?: string | null
        projectId?: number | null
        pageId?: string | null
        setParams?: Array<{ __typename?: 'Param'; key: string; value?: string | null }> | null
        toggleParams?: Array<{ __typename?: 'Param'; key: string; value?: string | null }> | null
      }
    }> | null
  } | null
  panels: Array<{
    __typename?: 'Panel'
    title?: string | null
    collapsible?: boolean | null
    tiles: Array<{
      __typename?: 'Tile'
      title?: string | null
      collapsible?: boolean | null
      caption?: string | null
      allowContentCopy?: boolean | null
      allowContentDownload?: boolean | null
      filters: Array<
        | {
            __typename: 'BooleanField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            state?: boolean | null
            localEdited?: boolean | null
            localState?: boolean | null
          }
        | {
            __typename: 'DateField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            date?: any | null
            localEdited?: boolean | null
            localDate?: string | null
          }
        | {
            __typename: 'DateTimeField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            dateTime?: any | null
            localEdited?: boolean | null
            localDateTime?: string | null
          }
        | {
            __typename: 'DownloadFileField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            selection?: {
              __typename?: 'SelectField'
              style?: Types.SelectStyle | null
              localEdited?: boolean | null
              id: string
              label?: string | null
              description?: string | null
              information?: string | null
              options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
              selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
              localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
            } | null
          }
        | {
            __typename: 'MultiSelectField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            style?: Types.SelectStyle | null
            localEdited?: boolean | null
            options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
            selections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
            localSelections?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
          }
        | {
            __typename: 'NumberField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            value?: number | null
            localEdited?: boolean | null
            localValue?: number | null
          }
        | {
            __typename: 'NumberRangeField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
          }
        | {
            __typename: 'SelectField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            style?: Types.SelectStyle | null
            localEdited?: boolean | null
            options?: Array<{ __typename?: 'SelectOption'; label: string; value: string }> | null
            selection?: { __typename?: 'SelectOption'; label: string; value: string } | null
            localSelection?: { __typename?: 'SelectOption'; label: string; value: string } | null
          }
        | {
            __typename: 'TextField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            text?: string | null
            localEdited?: boolean | null
            localText?: string | null
          }
        | {
            __typename: 'UploadFileField'
            id: string
            label?: string | null
            description?: string | null
            information?: string | null
            overrideAppId?: string | null
            templateId?: string | null
            entityId?: string | null
          }
      >
      shallowContent?:
        | { __typename?: 'Chart' }
        | { __typename?: 'DataTemplate' }
        | { __typename?: 'Form'; id: string }
        | { __typename?: 'Metric'; id: string }
        | { __typename?: 'Table'; id: string }
        | { __typename?: 'VegaLiteChart'; id: string }
        | null
    }>
  }>
  meta: {
    __typename?: 'Meta'
    label: string
    description?: string | null
    experimental: boolean
    allowPublicAccess: boolean
    requireSuperuser: boolean
    requireAdmin: boolean
    requireDeveloper: boolean
    requireInternal: boolean
  }
}

export const ComponentMetaFragmentDoc = gql`
  fragment ComponentMeta on ComponentI {
    id
    meta {
      label
      description
      experimental
      allowPublicAccess
      requireSuperuser
      requireAdmin
      requireDeveloper
      requireInternal
    }
  }
`
export const PageFragmentDoc = gql`
  fragment Page on Page {
    ...ComponentMeta
    title
    background {
      imageUrl
    }
    banner {
      title
      subtitle
    }
    link {
      ...ActionLink
      ...NavLink
      ...ExternalLink
    }
    quickLinks {
      position
      links {
        ...QuickLink
      }
    }
    panels {
      ...Panel
    }
  }
  ${ComponentMetaFragmentDoc}
  ${ActionLinkFragmentDoc}
  ${NavLinkFragmentDoc}
  ${ExternalLinkFragmentDoc}
  ${QuickLinkFragmentDoc}
  ${PanelFragmentDoc}
`
